import { DatePicker } from "antd";
import type { Dayjs } from "dayjs";
import styled from "styled-components";

export interface DateRangeControlsProps {
  from: Dayjs;
  to: Dayjs;
  onFromChange: (iso: string | null) => void;
  onToChange: (iso: string | null) => void;
}

// Row: full width with 8px gap
const PickerRow = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
`;

// Wrapper: each picker grows, forces inner picker to 100% width
const PickerWrapper = styled.div`
  flex: 1;
  min-width: 160px;

  .ant-picker {
    width: 100%;
    background: #393e46; /* background color */
    border-color: #222831;
    color: #eeeeee;
  }

  /* Input text color */
  .ant-picker-input > input {
    color: #eeeeee;
    caret-color: #eeeeee;
  }

  /* Placeholder color */
  .ant-picker-input > input::placeholder {
    color: #eeeeee;
    opacity: 0.7;
  }

  /* Suffix icon (calendar) */
  .ant-picker-suffix .anticon svg {
    fill: #eeeeee;
    color: #eeeeee;
  }

  /* Clear icon */
  .ant-picker-clear .anticon svg {
    fill: #eeeeee;
    color: #eeeeee;
  }

  /* Hover/focus states */
  .ant-picker:hover {
    border-color: #8e1616;
  }
  .ant-picker-focused {
    border-color: #8e1616;
    box-shadow: 0 0 0 2px rgba(142, 22, 22, 0.2);
  }

  /* Dropdown panel colors (optional) */
  .ant-picker-panel {
    background: #393e46;
    color: #eeeeee;
  }
  .ant-picker-cell .ant-picker-cell-inner {
    color: #eeeeee;
  }
  .ant-picker-header,
  .ant-picker-footer {
    background: #393e46;
    color: #eeeeee;
    border-color: #222831;
  }
`;

export default function DateRangeControls({
  from,
  to,
  onFromChange,
  onToChange,
}: DateRangeControlsProps) {
  return (
    <PickerRow>
      <PickerWrapper>
        <DatePicker
          placeholder="From date"
          value={from}
          onChange={(v: Dayjs | null) =>
            onFromChange(v ? v.toISOString() : null)
          }
        />
      </PickerWrapper>
      <PickerWrapper>
        <DatePicker
          placeholder="To date"
          value={to}
          onChange={(v: Dayjs | null) => onToChange(v ? v.toISOString() : null)}
        />
      </PickerWrapper>
    </PickerRow>
  );
}
